import React from 'react';
import PropTypes from 'prop-types';
import { setPageTitle } from 'utils';
import { I18NConsumer } from './I18N';

const NotAuthorized = ({ orgName, message }) => (
  <I18NConsumer>
    {(i18n) => {
      setPageTitle(`${orgName} - ${i18n.get('error.406.label')}`);

      return (
        <div className="error-page error-401">
          <p className="title">
            {i18n['error.406.title']}
          </p>
          {message && <p><strong>{message}</strong></p>}
        </div>
      );
    }}
  </I18NConsumer>
);

NotAuthorized.propTypes = {
  orgName: PropTypes.string.isRequired,
  message: PropTypes.string,
};

NotAuthorized.defaultProps = {
  message: '',
};

export default NotAuthorized;
